import { createRouter, createWebHistory, Router, RouteRecordRaw } from 'vue-router';
import UserPortal from '@/pages/UserPortal/UserPortal.vue';
import { Forms } from '@/enums/Forms';

export const routes: RouteRecordRaw[] = [
  {
    component: UserPortal,
    name: Forms.SIGN_IN,
    path: '/'
  },
  {
    component: UserPortal,
    name: Forms.SIGN_UP,
    path: '/signup'
  },
  {
    component: UserPortal,
    name: Forms.SIGNED_IN,
    path: '/account'
  },
  {
    component: UserPortal,
    name: Forms.SERVICES,
    path: '/account/services'
  },
  {
    component: UserPortal,
    name: Forms.PROFILE,
    path: '/account/profile'
  },
  {
    component: UserPortal,
    name: Forms.CHANGE_PASSWORD,
    path: '/changepassword'
  },
  {
    component: UserPortal,
    name: Forms.FORGOT_PASSWORD,
    path: '/forgotpassword'
  },
  {
    component: UserPortal,
    name: Forms.RESET_PASSWORD,
    path: '/resetpassword'
  },
  {
    component: UserPortal,
    name: Forms.ACTIVATE,
    path: '/activate'
  }
];

export const router: Router = createRouter({
  history: createWebHistory(),
  routes
});

router.beforeEach((to, from, next) => {
  document.title = to.name ? 'Polteq ID ' + to.name.toString() : 'Polteq ID';
  next();
});
